import { render, staticRenderFns } from "./RetornoBanco.vue?vue&type=template&id=04d97176"
import script from "./RetornoBanco.vue?vue&type=script&lang=js"
export * from "./RetornoBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports